import {
  FlexProps as MantineFlexProps,
  Flex as MantineFlex,
} from '@mantine/core';

export type FlexProps = MantineFlexProps;

export const Flex = MantineFlex as typeof MantineFlex;

Flex.displayName = 'Flex';
